import { Auth } from "aws-amplify";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";

export const MICROSOFT_IDENTITY_PROVIDER = process.env.REACT_APP_COGNITO_MICROSOFT_PROVIDER_NAME || "Microsoft";

export const isSocialAuthConfigured = (): boolean => Boolean(process.env.REACT_APP_COGNITO_APP_CLIENT_DOMAIN);

export const getOauthRedirectError = (): string => {
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error_description") || params.get("error");
  if (!error) {
    return "";
  }
  return decodeURIComponent(error.replace(/\+/g, " "));
};

export const signInWithGoogle = () => Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });

export const signInWithMicrosoft = () => Auth.federatedSignIn({ customProvider: MICROSOFT_IDENTITY_PROVIDER });
